<template>
    <div>
        <button-secondary v-if="booking.mail_message_id" @click="open"><i class="fa fa-envelope"></i></button-secondary>

        <portal to="modal" v-if="showPopup">
            <modal @close="showPopup = false">

                <template v-slot:header>E-Mail ansehen</template>

                <div v-if="!loading" class="grid">
                    <div class="mb-4">Empfänger: <slot>{{to}}</slot></div>
                    <div class="mb-4">Betreff: <slot>{{subject}}</slot></div>
                    <div class="mb-4" v-html="body"></div>
                    <div class="mb-4" v-show="attachment"><a :href="'/admin/mail_messages/' + booking.mail_message_id + '/attachment'">Anhang herunterladen</a></div>
                </div>

                <loading v-show="loading"></loading>

                <div class="flex justify-end" v-show="!loading">
                    <button-secondary class="ml-2" @click="showPopup = false">
                        <i></i> Schließen
                    </button-secondary>
                </div>

            </modal>
        </portal>
    </div>
</template>

<script>
import Modal from "./Modal";
import Loading from "./UI/Loading";
import ConfirmDialog from "./UI/ConfirmDialog.vue";
import ButtonDelete from "./UI/ButtonDelete.vue";
import ButtonPrimary from "./UI/ButtonPrimary.vue";
import ButtonSecondary from "./UI/ButtonSecondary.vue";
import InputText from "./UI/InputText.vue";

export default {
    name: "ConferenceRoomCustomEmail",
    components: {
        InputText,
        ButtonSecondary,
        ButtonPrimary,
        ButtonDelete,
        ConfirmDialog,
        Loading,
        Modal,
    },

    inject: ['group'],

    data: () => ({
        showModal: false,
        loading: false,
        showPopup: false,
        body: '',
        subject: '',
        to: '',
        attachment: null,
    }),

    props: {
        booking: {},
    },

    filters: {
        date(val) {
            let [date, time] = val.split(' ');
            let [y, m, d] = date.split('-');
            return `${d}.${m}.${y}`;
        }
    },

    methods: {
        open(){
            this.loading = true;
            this.$http.get(`/admin/mail_messages/${this.booking.mail_message_id}`)
                .then(result => {
                    this.loading = false;

                    if(result.data.data.status === 'send'){
                        this.body = result.data.data.body;
                        this.subject = result.data.data.subject;
                        this.to = result.data.data.to;
                        this.attachment = result.data.data.attachment;

                        this.showPopup = true;
                    }else{
                        this.$root.$emit('email', this.booking.mail_message_id);
                    }

                })
                .catch(error => {
                    this.$root.$emit('error', error);
                });
        }
    }

}
</script>

<style scoped>

</style>
